import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentContextOpenedMethod } from './useTrackAgentContextOpened.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentContextOpenedMethod } from './useTrackAgentContextOpened.meta';

export type UseTrackAgentContextOpenedParams = {
  method: WorkspaceAgentContextOpenedMethod;
};

export const useTrackAgentContextOpened = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentContextOpened = useCallback(
    (params: UseTrackAgentContextOpenedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentContextOpened };
};
